import {
  clearLegacyUnscopedSearchHistory,
  getReadingStorageKey,
  getReadingStorageUser,
  normalizeReadingUid,
} from "./readingStorageScope";

export { clearLegacyUnscopedSearchHistory };

export const STORAGE_SEARCH_HISTORY = "bible_search_history";
export const SEARCH_HISTORY_LIMIT = 6;

const resolveSearchScope = (uid) =>
  uid !== undefined ? normalizeReadingUid(uid) : getReadingStorageUser();

const readHistoryList = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item) => typeof item === "string" && item.trim())
      .map((item) => item.trim());
  } catch (e) {
    return [];
  }
};

export const getSearchHistory = (uid) => {
  if (typeof localStorage === "undefined") return [];
  const scope = resolveSearchScope(uid);
  return readHistoryList(getReadingStorageKey(STORAGE_SEARCH_HISTORY, scope));
};

export const saveSearchHistory = (items, uid) => {
  if (typeof localStorage === "undefined") return [];
  const scope = resolveSearchScope(uid);
  const next = (Array.isArray(items) ? items : [])
    .filter((item) => typeof item === "string" && item.trim())
    .map((item) => item.trim())
    .slice(0, SEARCH_HISTORY_LIMIT);
  try {
    localStorage.setItem(
      getReadingStorageKey(STORAGE_SEARCH_HISTORY, scope),
      JSON.stringify(next)
    );
  } catch (e) {
    // ignore quota / private-mode errors
  }
  return next;
};

export const recordSearchTerm = (term, uid) => {
  const trimmed = typeof term === "string" ? term.trim() : "";
  if (!trimmed) return getSearchHistory(uid);
  const filtered = getSearchHistory(uid).filter((item) => item !== trimmed);
  return saveSearchHistory([trimmed, ...filtered], uid);
};

export const clearSearchHistory = (uid) => {
  if (typeof localStorage === "undefined") return;
  const scope = resolveSearchScope(uid);
  try {
    localStorage.removeItem(getReadingStorageKey(STORAGE_SEARCH_HISTORY, scope));
  } catch (e) {
    // ignore quota / private-mode errors
  }
};
